import ActivityContent from 'components/activity-display/ActivityContent';
import { Activity, ActivityCategory } from "interfaces/ActivityInterfaces";
import PaddingWrap from 'components/shared/PaddingWrap';
import { Card, CardHeader, CardContent } from '@mui/material';
import ActivityCategoryDisplay from 'components/activity-display/ActivityCategoryDisplay';

interface ActivitiesFullWidthProps {
	activities: Activity[];
	activityCategory: ActivityCategory | null;
}

function ActivitiesFullWidth({ activities, activityCategory }: ActivitiesFullWidthProps) {

	return (
		<>
			{
				activityCategory && (
					<ActivityCategoryDisplay activityCategory={activityCategory} />
				)
			}
			{
				activities.map(activity => (
					<PaddingWrap key={activity.id}>
						<Card>
							<CardHeader
								title={<h2>{activity.title}</h2>}
							/>
							<CardContent>
								<ActivityContent activity={activity} />
							</CardContent>
						</Card>
					</PaddingWrap>
				))
			}
		</>
	);
}

export default ActivitiesFullWidth;